module.exports = __webpack_public_path__ + "static/media/icon_system_rituals_social_facebook.e50b0b34.svg";